import { GlobalEnumsAceStudienabschluss, KontaktDisplayModelFormGroup, StipendiumDisplayModelFormGroup } from '@/api/model-index';
import { Constants } from '@/constants';
import { EnumValue } from '@/core/models/enumvalue.model';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';

@Component({
  selector: 'stipendium',
  templateUrl: './stipendium.component.html',
  styleUrls: ['./stipendium.component.scss']
})
export class StipendiumComponent implements OnInit {

  @Input('form') public stipendiumForm: StipendiumDisplayModelFormGroup;
  public antragstellerForm: KontaktDisplayModelFormGroup;

  public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;

  public get dateFormat(): string{
    return this.translateService.GetCurrentShortDateFormat(true);
  }

  public get angestrebterStudienabschlussList(): EnumValue[] {
    let studienarten = GlobalEnumsAceStudienabschluss.getAsDataset();
    studienarten.forEach(x => x.Description = this.translateService.instant("Enum.GlobalEnumsAceStudienabschluss." + x.Name));
    return studienarten;
  }

  constructor(public translateService: I18nService, protected stateService: StateService) { 
  }
  
  ngOnInit(): void {
    this.antragstellerForm = KontaktDisplayModelFormGroup.Instance;
    this.antragstellerForm.Iban.patchValue(this.stipendiumForm.Iban.value);
    this.antragstellerForm.Bic.patchValue(this.stipendiumForm.Bic.value);
    this.antragstellerForm.Kontoinhaber.patchValue(this.stipendiumForm.Kontoinhaber.value);
    this.antragstellerForm.NameDesKreditInstituts.patchValue(this.stipendiumForm.NameDesKreditInstituts.value);

    this.antragstellerForm.valueChanges.subscribe(() => {
      this.stipendiumForm.Iban.patchValue(this.antragstellerForm.Iban.value);
      this.stipendiumForm.Bic.patchValue(this.antragstellerForm.Bic.value);
      this.stipendiumForm.Kontoinhaber.patchValue(this.antragstellerForm.Kontoinhaber.value);
      this.stipendiumForm.NameDesKreditInstituts.patchValue(this.antragstellerForm.NameDesKreditInstituts.value);
      this.stipendiumForm.markAsDirty();
    })

    this.stipendiumForm.Title.disable();
    this.stipendiumForm.BeantragteFoerdersumme.disable();

    if (this.stateService.IsEndvalidationEnabled) {
      this.stipendiumForm.Title.addValidators(Validators.required);
      this.stipendiumForm.Studienbeginn.addValidators(Validators.required);
      this.stipendiumForm.Studienende.addValidators(Validators.required);
      this.stipendiumForm.Studienfach.addValidators(Validators.required);
      this.stipendiumForm.Universitaet.addValidators(Validators.required);
      this.stipendiumForm.AngestrebterStudienabschluss.addValidators(Validators.required);
      this.stipendiumForm.Immatrikulationsnummer.addValidators(Validators.required);
      this.stipendiumForm.markAllAsTouched();
    }
  }
  
  onStudienbeginnChange(event: any): void {
    this.stipendiumForm.Studienende.setValue(null);
  }
}
